import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#454545",
      "fill-opacity": ".5",
      rx: "22"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M35 10.374 33.627 9 22 20.64 10.373 9 9 10.374l11.636 11.63L9 33.637 10.373 35 22 23.37 33.627 35 35 33.636 23.364 22.005 35 10.374Z"
    }, null, -1)
  ])))
}
export default { render: render }